export class GSIconListModel {
  Id: string = '';
  Header: string = '';
  Subheader: string = '';
  BulletList: GSIconListBulletModel[] = [];
}

export class GSIconListBulletModel {
  IconPath: string = '';
  IconAltText: string = '';
  BulletTitle = '';
  BulletText = '';
  ShowBullet = true;
}
